export class UFEntidade {
	public CD_UNID_FED?: string;
	public DS_UNID_FED?: string;
	public FX1_INIC_CEP_UF?: string;
	public FX1_TERM_CEP_UF?: string;
	public FX2_INIC_CEP_UF?: string;
	public FX2_TERM_CEP_UF?: string;
}